// extracted by mini-css-extract-plugin
module.exports = {"LogoAndTitle__imageWrapper":"LogoAndTitle_LogoAndTitle__imageWrapper__1qNeZ","LogoAndTitle__cancel":"LogoAndTitle_LogoAndTitle__cancel__wEJEU"};